/**
 * Created by claude on 2026-02-09
 * Scene component extracted from cleverapps.FixedWidthScene
 */

class SceneComponent extends ScriptComponent {
    onCreate() {
        if (typeof this.options.sceneName === "string") {
            this.options = { ...this.options, sceneName: cleverapps.Environment[this.options.sceneName] || this.options.sceneName };
        }

        this.bundles = this.options.bundles;
        this.styling = this.options.styling;
        this.audioStyles = this.options.audioStyles || cleverapps.styles.SceneComponent.sound;
    }

    setStyling(styling) {
        this.styling = styling;
    }

    setAudioStyles(audioStyles) {
        this.audioStyles = audioStyles;
    }

    setBundles(bundles) {
        this.bundles = bundles;
    }

    onAttach() {
        this.node.sceneComponent = this;

        this.node.avoidNodes = {};
        this.node.dynamicNodes = {};

        this.node.retainBundlesEnabled = this.options.retainBundles !== undefined ? this.options.retainBundles : SceneComponent.RETAIN_SCENE_BUNDLES;

        const screen = this.node.screen = new cc.Node();
        screen.setLocalZOrder(-10);
        this.node.addChild(screen);

        this.node.updateDynamicNodesThrottled = cleverapps.accumulate(0, this.node.createListener(this.updateDynamicNodes.bind(this)));
    }

    closeAction() {
        if (cleverapps.focusManager.isFocused()) {
            return;
        }

        if (cleverapps.git && !cleverapps.git.handleSceneClose()) {
            return;
        }

        if (this.node.onCloseAction && this.node.onCloseAction()) { // todo - remove after all scenes become components
            return;
        }

        ComponentMap.callFirstHook(this.node, "onCloseAction");
    }

    onCloseAction() {
        if (!cleverapps.environment.isMainScene()) {
            cleverapps.focusManager.display({
                focus: "closeScene",
                action: function (f) {
                    cleverapps.meta.gotoMainLocation(f);
                }
            });
        }
        return true;
    }

    transitionAnimationDidStart() {
        if (this.node.onTransitionAnimationDidStart && this.node.onTransitionAnimationDidStart()) { // todo - remove after all scenes become components
            return;
        }

        ComponentMap.callFirstHook(this.node, "onTransitionAnimationDidStart");
    }

    onTransitionAnimationDidStart() {
        cleverapps.audio.fadeOutAndEject(0.1);
    }

    playIntro(f, silent) {
        if (this.node.onPlayIntro && this.node.onPlayIntro(f, silent)) { // todo - remove after all scenes become components
            return;
        }

        ComponentMap.callFirstHook(this.node, "onPlayIntro", f, silent);
    }

    onPlayIntro(f) {
        f();
    }

    prepareBundles(prevScene) {
        this.node.bundles = (this.bundles || []).concat(this.listBaseBundles());
        this.node.bundles = cleverapps.unique(this.node.bundles.filter((name) => name && bundles[name]));

        let retainedBundles = [];

        if (prevScene.retainBundlesEnabled) {
            if (cleverapps.equals(prevScene.bundles, this.node.bundles)) {
                retainedBundles.push(...prevScene.bundles);
                retainedBundles.push(...prevScene.prevSceneBundles);
            } else {
                retainedBundles.push(...prevScene.bundles);
                retainedBundles.push(...cleverapps.intersect(prevScene.prevSceneBundles, this.node.bundles));
            }
        } else {
            retainedBundles.push(...cleverapps.intersect(prevScene.bundles, this.node.bundles));
            retainedBundles.push(...cleverapps.intersect(prevScene.prevSceneBundles, this.node.bundles));
        }

        retainedBundles = cleverapps.unique(retainedBundles);

        this.node.prevSceneBundles = retainedBundles;
    }

    load(f, retries = 0) {
        cleverapps.lazyAssets.setPreferredBundles(this.options.lazyBundles || []);

        const toLoad = cleverapps.substract(this.node.bundles, this.node.prevSceneBundles);

        cleverapps.bundleLoader.loadBundles(toLoad, {
            onSuccess: function () {
                f();
            },
            onFailure: (errors) => {
                cleverapps.focusManager.display({
                    focus: "loadSceneBundlesFailure",
                    stack: true,
                    action: (f2) => {
                        ErrorHandler.showRestartWindow({
                            errors,
                            retries,
                            onRetry: () => {
                                f2();
                                cleverapps.bundleLoader.deleteBundles(toLoad);
                                this.load(f, retries + 1);
                            }
                        });
                    }
                });
            }
        });
    }

    unload(nextScene) {
        const retainedBundles = nextScene.prevSceneBundles;

        let toDelete = [];
        toDelete.push(...cleverapps.substract(this.node.bundles, retainedBundles));
        toDelete.push(...cleverapps.substract(this.node.prevSceneBundles, retainedBundles));
        toDelete = cleverapps.unique(toDelete);

        cleverapps.bundleLoader.deleteBundles(toDelete);
        cleverapps.bundleLoader.clearUnusedResources();
        cleverapps.pool.drainAllPools();
    }

    handleSceneLoaded() {
        ComponentMap.callHooks(this.node, "onBeforeSceneLoaded");

        if (this.node.onBeforeSceneLoaded) { // todo - remove after all scenes become components
            this.node.onBeforeSceneLoaded();
        }

        ComponentMap.callHooks(this.node, "onSceneLoaded");

        if (this.node.onSceneLoaded) { // todo - remove after all scenes become components
            this.node.onSceneLoaded();
        }

        if (this.context.config) {
            PrefabBuilder.createChildren(this.context.config, this.context, this.node);
        }

        ComponentMap.callHooks(this.node, "onReady");
    }

    onSceneLoaded() {
        const sceneName = this.options.sceneName;
        cleverapps.environment.setScene(sceneName);

        this.node.movingNode = new cc.Node();
        this.node.movingNode.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 3);
        this.node.addChild(this.node.movingNode);

        const shadow = new ShadowLayer();
        shadow.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 3);
        shadow.subscribeToModel();

        const loading = new LoadingAnimation();
        loading.visible = false;
        loading.setLocalZOrder(1000);
        loading.subscribeToModel();
        loading.setAlignment(cleverapps.styles.SceneComponent.loading);
        this.node.addChild(loading);

        this.setBackground();

        this.addTreasureBag();

        // A scene prefab declares the up menu among its children - one built in js has no prefab to
        // declare it in, so it gets one here.
        if (!this.context.config && !this.options.noMenuBar) {
            this.node.addChild(Prefab.instantiate(bundles.upmenu.jsons.upmenu_prefab_json, {
                theme: bundles.theme.jsons.theme_prefab_json
            }));
        }

        this.addDebugToolsBar();

        this.node.addChild(new CenterHintView(cleverapps.centerHint));

        this.startOrRestartMusic(this.audioStyles);

        if (cleverapps.flyingAd) {
            cleverapps.flyingAd.reset();
        }

        cleverapps.userStatus.initTimeouts();

        cc.director.setClearColor(cleverapps.styles.SceneComponent.clearColor || cc.color.BLACK);

        this.node.debugId = "Scene";

        if (cleverapps.restoreProgress.isAvailable()) {
            const restoreProgress = new RestoreProgressButton();
            this.node.addChild(restoreProgress);
        }

        cleverapps.scenes.onAvoidNodeVisibilityChanged = this.node.updateDynamicNodesThrottled.bind(this.node);
    }

    startOrRestartMusic(styles) {
        this.node.startMusicAction = this.node.runAction(new cc.Sequence(
            new cc.DelayTime(styles.delay || 0),
            new cc.CallFunc(() => {
                if (styles.res !== cleverapps.audio.disk) {
                    cleverapps.audio.insertDisk(styles.res);
                    cleverapps.audio.fadeIn(styles.fadeIn || 0);
                } else {
                    cleverapps.audio.fadeIn(0);
                }
            })
        ));
    }

    // The sidebar is declared among a scene prefab's children, so whether the scene has one is
    // answered before it is built.
    hasSideBar() {
        return !cleverapps.gameModes.noSidebar;
    }

    // The toolbar is declared the same way, by the scenes that carry one.
    hasToolbar() {
        return !cleverapps.gameModes.noControls && !cleverapps.gameModes.noToolbar;
    }

    addTreasureBag() {
        if (this.node.treasureBag) {
            this.node.treasureBag.removeFromParent();
            this.node.treasureBag = undefined;
        }

        const control = this.node.treasureBag = new cc.Node();
        control.addChild(new TreasureBagIcon());
        this.node.addChild(control);

        ComponentMap.attach(control, new HidingComponent({
            direction: cleverapps.styles.TreasureBag.hideVertical ? cleverapps.UI.VERTICAL : cleverapps.UI.HORIZONTAL,
            control: "treasureBag",
            hiddenByDefault: Object.values(cleverapps.Environment)
        }));
    }

    addDebugToolsBar() {
        if (!cleverapps.config.debugMode || !cleverapps.environment.isGameScene() && !cleverapps.environment.isMainScene()) {
            return;
        }

        if (!cleverapps.git) {
            return;
        }

        const styles = cleverapps.styles.SceneComponent;

        this.node.gitButtons = new GitButtonsView({
            hiddenByDefault: true
        });
        this.node.gitButtons.setLocalZOrder(1000);
        this.node.gitButtons.setAlignment(styles.gitButtons);
        this.node.addChild(this.node.gitButtons);
    }

    setBackground(styling) {
        styling = styling || this.styling;

        if (!styling || cleverapps.gameModes.noBg) {
            return;
        }

        if (styling.patternId) {
            const winSize = cleverapps.resolution.getSceneSize();
            winSize.height += 2;

            this.node.background = new cc.Node();
            this.node.background.setAnchorPoint(0.5, 0.5);
            this.node.background.setContentSize(winSize);

            const pattern = cleverapps.UI.createPatternSprite(bundles[styling.bundle].urls[styling.patternId], winSize);
            this.node.background.addChild(pattern);
        } else if (styling.horizontalPattern) {
            let layoutWidth = 0;
            const layoutItems = [];

            do {
                const bgSprite = new cc.Sprite(styling.horizontalPattern);
                layoutItems.push(bgSprite);
                layoutWidth += bgSprite.width;
            } while (layoutWidth < this.node.width || layoutItems.length < 2);

            this.node.background = new cleverapps.Layout(layoutItems, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: 0
            });
        } else if (styling.scale9) {
            this.node.background = cleverapps.UI.createScale9Sprite(styling.scale9, cleverapps.UI.Scale9Rect.TwoPixelXY);
        } else if (styling.movableAnimation) {
            this.node.background = new cleverapps.Spine(styling.movableAnimation);
            this.node.background.setAnimation(0, "animation", true);
        } else if (styling.backgroundId) {
            this.node.background = new cc.Sprite(bundles[styling.bundle].urls[styling.backgroundId]);
        } else {
            return;
        }

        if (styling.animation) {
            const animation = this.node.background.animation = new cleverapps.Spine(styling.animation);
            animation.setAnimation(0, "animation", true);
            if (styling.skin) {
                animation.setSkin(styling.skin);
            }
            this.node.background.addChild(animation);
        }

        this.updateBackgroundScale();
        this.updateBackgroundPosition();

        this.node.background.setLocalZOrder(-10);
        this.node.addChild(this.node.background);
    }

    onResizeWhileNotLoaded() {
        const safePadding = cleverapps.resolution.getSafePadding();

        this.node.setContentSize(cleverapps.resolution.getSceneSize());
        this.node.setPosition(safePadding.left, safePadding.bottom);

        this.node.screen.setContentSize(cleverapps.resolution.getBgSize());
        this.node.screen.setPosition(-safePadding.left, -safePadding.bottom);
    }

    onResize() {
        this.removeFilmEffect();
        this.onResizeWhileNotLoaded();
        this.updateBackgroundScale();
        this.updateBackgroundPosition();
    }

    onAfterResize() {
        this.node.updateDynamicNodesThrottled(true);
    }

    updateBackgroundPosition() {
        if (this.node.background && !(this.styling && this.styling.movableAnimation)) {
            const bgSize = cleverapps.resolution.getBgSize();

            if (this.styling && this.styling.position) {
                this.node.background.setAlignment(this.styling.position);
                this.node.background.originalPosition = this.styling.position;
            } else {
                this.node.background.setAlignment(this.node.convertToNodeSpace(cc.p(bgSize.width / 2, bgSize.height / 2)));
            }
        }
    }

    updateBackgroundScale() {
        if (this.node.background && !(this.styling && this.styling.movableAnimation)) {
            const style = this.styling;

            if (this.node.background instanceof cc.Scale9Sprite) {
                const size = cleverapps.resolution.getBgSize();
                this.node.background.setContentSize2(size.width, size.height);
            } else if (typeof style.scale === "number") {
                this.node.background.setScale(style.scale);
            } else {
                const bgSize = cleverapps.resolution.getBgSize();
                const backgroundSize = style.size || this.node.background.getContentSize();

                const scale = Math.max(
                    bgSize.width / backgroundSize.width,
                    bgSize.height / backgroundSize.height
                );
                this.node.background.setScale(scale);
                this.node.background.stopAllActions();
            }

            if (this.node.background.animation) {
                this.node.background.animation.setAlignment(this.node.background.width / 2, this.node.background.height / 2);
            }
        }
    }

    destructor() {
        cleverapps.sideBar.clearListeners();
        cleverapps.centerHint.destructor();

        cleverapps.menuBar.clean();
        cleverapps.aims.clear();
        cleverapps.focusManager.clearTempControls();

        this.node.updateDynamicNodes = cleverapps.EMPTY_FUNCTION;
        this.node.updateDynamicNodesThrottled = cleverapps.EMPTY_FUNCTION;

        cc.Base.PerformRecursive(this.node, (node) => {
            cleverapps.pointerManager.removeAll(node);
            node.stopAllActions();
            if (node instanceof cleverapps.Spine) {
                node.setCompleteListener();
            }
        });

        ComponentMap.callHooks(this.node, "onDestruct");

        if (this.node.destructor) { // todo - remove after all scenes become components
            this.node.destructor();
        }
    }

    isSceneReady() {
        return !this.node.isAboutToRemove && !this.node.isAboutToShow;
    }

    listBaseBundles() {
        let result = ["main", "ui"];

        if (cleverapps.config.debugMode) {
            result.push("dev_resources");
        }
        if (cleverapps.skins.getBundles()) {
            result = result.concat(cleverapps.skins.getBundles());
        }
        if (bundles["persons_important"]) {
            result.push("persons_important");
        }

        return result;
    }

    addDynamicNode(node) {
        if (!this.node.dynamicNodes[node.__instanceId]) {
            this.node.dynamicNodes[node.__instanceId] = node;
        }
    }

    removeDynamicNode(node) {
        if (this.node.dynamicNodes[node.__instanceId]) {
            delete this.node.dynamicNodes[node.__instanceId];
        }
    }

    addAvoidNode(node) {
        if (!this.node.avoidNodes[node.__instanceId]) {
            this.node.avoidNodes[node.__instanceId] = node;
            this.node.updateDynamicNodesThrottled();
        }
    }

    removeAvoidNode(node) {
        if (this.node.avoidNodes[node.__instanceId]) {
            delete this.node.avoidNodes[node.__instanceId];
            this.node.updateDynamicNodesThrottled();
        }
    }

    updateDynamicNodes(silent) {
        Object.values(this.node.dynamicNodes).forEach((node) => {
            node.updateDynamicPosition(silent);
        });
    }

    getAvoidNodes(types) {
        types = cleverapps.createSet(types);

        return Object.values(this.node.avoidNodes).filter((node) => types[node.avoidNode]);
    }

    createFilmEffect(options) {
        this.removeFilmEffect();

        this.node.filmEffect = new SceneFilmEffect(options);
        this.node.addChild(this.node.filmEffect);
    }

    removeFilmEffect(timeout, callback) {
        if (!this.node.filmEffect) {
            if (callback) {
                callback();
            }
            return;
        }

        this.node.filmEffect.hideAnimation(timeout, () => {
            delete this.node.filmEffect;
            if (callback) {
                callback();
            }
        });
    }
}

Prefab.registerComponent("SceneComponent", SceneComponent);

SceneComponent.retainBetweenScenes = function (node) {
    SceneComponent.RETAINED_NODES.add(node);

    node.addCleaner(() => {
        SceneComponent.RETAINED_NODES.delete(node);
    });
};

SceneComponent.RETAINED_NODES = new Set();

SceneComponent.RETAIN_SCENE_BUNDLES = true;

cleverapps.styles.SceneComponent = {
    loading: {
        x: { align: "center" },
        y: { align: "center" }
    },

    sound: {
        res: bundles.main.urls.background_music_map,
        delay: 0.5
    },

    gitButtons: {
        x: { align: "right", dx: -4 },
        y: { align: "bottom", dy: 90 }
    }
};
